// Available action types that our action creators can emit and our reducers respond to.
export const types = {
    true: "TRUE",
    false: "FALSE",
    toggle: "TOGGLE",
    listIndexFalse: "LIST_FALSE",
    listIndexTrue: "LIST_TRUE",
    listAllTrue: "LIST_ALL_TRUE",
    listAllFalse: "LIST_ALL_FALSE",
    bottom: "BOTTOM",
    left: "LEFT",
    right: "RIGHT",
    top: "TOP",
    screenDimensions: "SCREEN_DIMENSIONS",
    breakpoint: "BREAKPOINT_REACHED",
};

// Boolean Action Creators
export const toggle = () => {
    return { type: types.toggle };
};

export const expand = () => {
    return { type: types.true };
};
export const collapse = () => {
    return { type: types.false };
};

export const open = () => {
    return { type: types.true };
};
export const close = () => {
    return { type: types.false };
};

export const show = () => {
    return { type: types.true };
};
export const hide = () => {
    return { type: types.false };
};

export const active = () => {
    return { type: types.true };
};
export const inactive = () => {
    return { type: types.false };
};

export const summon = () => {
    return { type: types.true };
};
export const dismiss = () => {
    return { type: types.false };
};

// Boolean List Action Creators

/**
 * Creates action to expand the *index*
 * @param {Number} index to expand
 * @param {Boolean} single define whether the list should have a single or multiple *true*
 * @returns {Object} action object
 */
export const expandItem = (index, single) => {
    return { type: types.listIndexTrue, index, single };
};

/**
 * Creates action to collapse the *index*
 * @param {Number} index to collpase
 * @returns {Object} action object
 */
export const collapseItem = (index) => {
    return { type: types.listIndexFalse, index };
};

export const expandAll = () => {
    return { type: types.listAllTrue };
};
export const collapseAll = () => {
    return { type: types.listAllFalse };
};

/**
 * Creates action to setActiveIndex the *index*
 * @param {Number} index to set active
 * @param {Boolean} single define whether the list should have a single or multiple *true*
 * @returns {Object} action object
 */
export const setActiveIndex = (index, single) => {
    return { type: types.listIndexTrue, index, single };
};

/**
 * Creates action to setInactiveIndex the *index*
 * @param {Number} index to set as inactive
 * @returns {Object} action object
 */
export const setInactiveIndex = (index) => {
    return { type: types.listIndexFalse, index };
};

/**
 * Creates action to selectItem the *index*
 * @param {Number} index to select
 * @param {Boolean} single define whether the list should have a single or multiple *true*
 * @returns {Object} action object
 */
export const selectItem = (index, single) => {
    return { type: types.listIndexTrue, index, single };
};

/**
 * Creates action to unselectItem the *index*
 * @param {Number} index to remove the selection from
 * @param {Boolean} single define whether the list should have a single or multiple *true*
 * @returns {Object} action object
 */
export const unselectItem = (index) => {
    return { type: types.listIndexFalse, index };
};

/**
 * Creates an action to update the state with the current screen width and height
 * @param {number} width
 * @param {number} height
 * @returns {object} action object
 */

export const screenSize = (currentDimensions) => {
    return {
        payload: currentDimensions,
    };
};

/**
 * Creates an action to update the state with the current breakpoint
 * @param {object} breakpoint
 * @returns {object} action object
 */

export const breakpointReached = (breakpoint) => {
    return { payload: breakpoint };
};

export const resize = () => {
    return { type: types.true };
};
